import { render, staticRenderFns } from "./RevisionActionRenderer.vue?vue&type=template&id=d675a91c"
import script from "./RevisionActionRenderer.vue?vue&type=script&lang=js"
export * from "./RevisionActionRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports